import { render } from "./tax.vue?vue&type=template&id=f7d6ae1e&ts=true"
import script from "./tax.vue?vue&type=script&lang=ts"
export * from "./tax.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__